<template>
  <el-dialog
    modal-append-to-body
    class="dialogContainer"
    id="downloadDialog"
    :visible.sync="dialogVisible"
    width="40%"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <template #title>
      <div class="title">{{ title }}</div>
    </template>
    <div class="main" ref="main" @scroll="load" style="overflow: auto">
      <div
        class="item"
        v-for="(item, index) in data"
        :key="index"
        @click="handleClick(index)"
      >
        <el-checkbox v-model="item.isCheck"></el-checkbox>
        <div class="code">{{ item.code || item.eventcode }}</div>
        <div class="address">{{ item.address }}</div>
      </div>
    </div>
    <el-checkbox v-model="checked" class="all" @change="selectAll" v-if="isShow"
      >全选</el-checkbox
    >
    <div class="promptInfo" v-else>当前数量大于十条，暂不支持全选</div>
    <template #footer>
      <div class="btn" @click="download" v-loading="loading">下载</div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  name: "DownloadDialog",
  props: {
    title: {
      type: String,
      require: true,
    },
    loading: {
      type: Boolean,
      require: false,
    },
    activeIndex: {
      type: Number,
      require: true,
    },
    isBatchDowlnload: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      dialogVisible: true,
      checked: false,
      data: [],
      page: 1,
      size: 10,
      flag: true,
    };
  },
  created() {
    this.decide();
  },
  // mounted() {},
  computed: {
    ...mapState(["userInfo"]),
    isShow() {
      if (this.data.length > 10) return false;
      return true;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleClick(i) {
      this.data[i].isCheck = !this.data[i].isCheck;
      this.isSelectAll();
    },
    // 是否全选
    isSelectAll() {
      if (
        this.data.filter((item) => item.isCheck === true).length ===
        this.data.length
      ) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    selectAll() {
      this.data.forEach((item) => {
        item.isCheck = this.checked;
      });
    },
    // 督查调令
    async getDispatchList() {
      try {
        const params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.uid = this.userInfo.gid;
        params.status = 1;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.DSIPATCH, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => (item.isCheck = false));
        if (res.rows.length !== 0) {
          this.data.push(...res.rows);
          this.flag = true;
        } else {
          this.flag = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 督查事件
    async getEventList() {
      try {
        const params = {};
        params.page = this.page;
        params.size = this.size;
        params.eid = this.userInfo.eid;
        params.uid = this.userInfo.gid;
        params.status = 9;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EVENT, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          if (item.p3 !== null) {
            item.p3 = item.p3.split("|");
          }
          item.isCheck = false;
        });
        if (res.rows.length !== 0) {
          this.data.push(...res.rows);
          this.flag = true;
        } else {
          this.flag = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取介入事件列表
    async getExpertintervention() {
      try {
        const params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.status = 1;
        params.starttime = this.startTime;
        params.endtime = this.endTime;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EXPERTINTERVENTION, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => (item.isCheck = false));
        if (res.rows.length !== 0) {
          this.data.push(...res.rows);
          this.flag = true;
        } else {
          this.flag = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取约谈事件列表
    async getInterviewList() {
      try {
        const params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.type = 1;
        params.status = 1;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.INTERVIEW, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          item.isCheck = false;
          item.address = item.object;
        });
        if (res.rows.length !== 0) {
          this.data.push(...res.rows);
          this.flag = true;
        } else {
          this.flag = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAccountability() {
      try {
        const params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.type = 2;
        params.status = 1;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.INTERVIEW, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          item.isCheck = false;
          item.address = item.object;
        });
        if (res.rows.length !== 0) {
          this.data.push(...res.rows);
          this.flag = true;
        } else {
          this.flag = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 加载更多
    load() {
      /**
       * 距离底部的距离 = 总体高度 - 可视区高度 - 被卷去顶部的高度
       * bottom = scrollHeight - clientHeight - scrollTop
       */
      const scrollHeight = this.$refs.main.scrollHeight;
      const clientHeight = this.$refs.main.clientHeight;
      const scrollTop = this.$refs.main.scrollTop;
      const bottom = scrollHeight - clientHeight - scrollTop;
      console.log(
        "scrollHeight",
        scrollHeight,
        clientHeight,
        scrollTop,
        bottom,
        this.flag
      );
      if (bottom <= 50 && this.flag) {
        this.flag = false;
        this.page += 1;
        // this.getDispatchList();
        this.decide();
      }
    },
    decide() {
      switch (this.activeIndex) {
        case 0:
          this.getDispatchList();
          break;
        case 1:
          this.getEventList();
          break;
        case 2:
          this.getExpertintervention();
          break;
        case 3:
          this.getInterviewList();
          break;
        case 4:
          this.getAccountability();
          break;
        default:
          break;
      }
    },
    // 下载
    download() {
      console.log(this.loading);
      if (this.loading) {
        this.$message.warning("请等待下载完成");
        return;
      }
      // this.loading = true;
      this.$emit("update:loading", true);
      this.$emit("update:isBatchDowlnload", true);
      const downloadArr = this.data.filter((item) => item.isCheck === true);
      this.$emit("batchDownload", downloadArr);
    },
  },
};
</script>

<style lang="less" scoped>
.dialogContainer {
  .title {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: #2c3a50;
    letter-spacing: 2px;
  }
  .main {
    height: 394px;
    margin-bottom: 10px;
    border: 1px solid #edeef3;
    border-radius: 4px;
    padding: 0 18px;
    // overflow: scroll;
    .item {
      height: 54px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #edeef3;
      cursor: pointer;
      .el-checkbox {
        margin-right: 28px;
      }
      .code {
        color: #353e56;
        font-size: 15px;
        letter-spacing: 1px;
        margin-right: 12px;
      }
      .address {
        opacity: 0.72;
        font-size: 15px;
        color: #838997;
      }
    }
  }
  .all {
    margin-bottom: 36px;
  }
  .promptInfo {
    margin-bottom: 36px;
    font-size: 12px;
  }
  .btn {
    width: 348px;
    height: 36px;
    line-height: 36px;
    background: #009157;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
  }
}
</style>